import React from 'react';
// import cssClasses from './Toolbar.css';
import './Toolbar.css';
import { MdMusicNote } from "react-icons/md";
// import NavigationItems from '../Navigation/NavigationItems/NavigationItems';

const toolbar = (props) => {

    return (
        <header>
            {/*<nav className={"navbar navbar-dark bg-dark " + cssClasses.Nav}>*/}
            {/*    <ul className="nav">*/}
            {/*        <li className="nav-item">*/}
            {/*            <a className="nav-link active" href="/">Active</a>*/}
            {/*        </li>*/}
            {/*        <li className="nav-item">*/}
            {/*            <a className="nav-link" href="/">Link</a>*/}
            {/*        </li>*/}
            {/*    </ul>*/}
            {/*    <ul className="nav justify-content-end">*/}
            {/*        <li className="nav-item">*/}
            {/*            <a className="nav-link" href="/">Login</a>*/}
            {/*        </li>*/}
            {/*    </ul>*/}
            {/*</nav>*/}
            {/* <NavigationItems /> */}

            <div>
                <p>Re-Music
                    {/*#64ffda*/}
                </p>
                <MdMusicNote style={{fontSize:"3em", color:"var(--green)"}}/>
            </div>
        </header>
    );

}

export default toolbar;